import { textContent } from '../components/common/utils';
export default textContent;
